import RespondentDashboardService, {
    getOrganisationInternationalSourcesofFunds,
    getOrganisationSurveyStatus,
    getOrganisationCapitalExpenditure,
    getOrganisationProvincialExpenditure,
    getOrganisationCategoriesOfExpenditure,
    getOrganisationHeadCounts,
    getQuestionFactsByOrganisationIdAndSurveyCycleAndQuestionId,
    getOrganisationFTECounts
} from './RespondentDashboardService';

export default { RespondentDashboardService, getOrganisationSurveyStatus, getOrganisationInternationalSourcesofFunds, getOrganisationCapitalExpenditure, getOrganisationProvincialExpenditure, getOrganisationCategoriesOfExpenditure, getOrganisationHeadCounts, getQuestionFactsByOrganisationIdAndSurveyCycleAndQuestionId: getQuestionFactsByOrganisationIdAndSurveyCycleAndQuestionId, getOrganisationFTECounts }